/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Czech
export default {
  'ai-floating-context-menu.ai-dynamic-surface.back': 'zpět',
  'ai-floating-context-menu.ai-dynamic-surface.close': 'zavřít',
  'ai-floating-context-menu.ai-dynamic-surface.referencing-panel-title': 'Odkazování',
  'ai-floating-context-menu.ai-dynamic-surface.rovo-panel-title': 'Rovo',
  'ai-smart-button.ai-actions.actions.section.text': 'Akce',
  'ai-smart-button.ai-actions.conversation-starters.loading.text': 'Načítání spouštěčů konverzací…',
  'ai-smart-button.ai-actions.conversation-starters.section.text': 'Zeptejte se nástroje Rovo',
  'ai-smart-button.ai-actions.give-feedback-action.title': 'Odeslat zpětnou vazbu',
  'ai-smart-button.ai-actions.help.section.text': 'Nápověda',
  'ai-smart-button.ai-actions.input.link-picker-button-label': 'Připojit',
  'ai-smart-button.ai-actions.input.mention-button-label': 'Zmínka',
  'ai-smart-button.ai-actions.input.placeholder': 'Napište, co potřebujete',
  'ai-smart-button.ai-actions.input.send-button-label': 'Odeslat',
  'ai-smart-button.ai-actions.item.betaLozenge': 'BETA',
  'ai-smart-button.ai-actions.item.newLozenge': 'NOVÉ',
  'ai-smart-button.ai-actions.no-results-heading': 'Zeptejte se nástroje Rovo',
  'ai-smart-button.ai-actions.no-results-text': 'Odesláním výzvy do nástroje Rovo zahájíte chat.',
  'ai-smart-button.ai-actions.rovo-agents.add-icon-label': 'Přidat ikonu',
  'ai-smart-button.ai-actions.rovo-agents.agent-icon-label': 'Ikona agenta',
  'ai-smart-button.ai-actions.rovo-agents.automation-icon-label': 'Ikona automatizace',
  'ai-smart-button.ai-actions.rovo-agents.automations.text': 'Automatizace',
  'ai-smart-button.ai-actions.rovo-agents.browse-agent.text': 'Procházet agenty',
  'ai-smart-button.ai-actions.rovo-agents.create-agent.text': 'Vytvořit agenta',
  'ai-smart-button.ai-actions.rovo-agents.create-automation.text': 'Vytvořit automatizaci',
  'ai-smart-button.ai-actions.rovo-agents.section.text': 'Studio',
  'ai-smart-button.ai-actions.static-agent-fallback-1': 'Co jsou agenti Rovo?',
  'ai-smart-button.ai-actions.static-agent-fallback-2': 'Jak mohu používat agenty Rovo ve svém prostoru Confluence?',
  'ai-smart-button.ai-actions.static-fallback-1': 'Co je Rovo Chat?',
  'ai-smart-button.ai-actions.static-fallback-2': 'Pomozte mi začít s nástrojem Rovo Chat',
  'ai-smart-button.ai-dynamic-surface.components.greeting.intro-second-line': 'jak můžu pomoci?',
  'ai-smart-button.ai-dynamic-surface.components.greeting.intro-text-headline': 'Dobrý den, {name},',
  'ai-smart-button.ai-proactive-nudge.dismiss': 'Zavřít',
  'ai-smart-button.feedback-action.ask-question-option': 'Položit otázku',
  'ai-smart-button.feedback-action.can-contact-message':
    'Ano, týmy {product} mě mohou kontaktovat ohledně mých zkušeností a pomoci s vylepšováním produktů a služeb společnosti Atlassian. Potvrzuji, že znám {privacyPolicy}',
  'ai-smart-button.feedback-action.can-contact-message-appify':
    'Ano, týmy {product} mě mohou kontaktovat ohledně mých zkušeností a pomoci s vylepšováním aplikací a služeb společnosti Atlassian. Potvrzuji, že znám {privacyPolicy}.',
  'ai-smart-button.feedback-action.cancel-button-label': 'Zrušit',
  'ai-smart-button.feedback-action.choose-feedback-option': 'Vyberte jednu možnost.',
  'ai-smart-button.feedback-action.feedback-entry-bug-heading': 'Popsat chybu nebo problém',
  'ai-smart-button.feedback-action.feedback-entry-comment-heading': 'Dejte nám vědět, co si myslíte',
  'ai-smart-button.feedback-action.feedback-entry-question-heading': 'Co byste chtěli vědět?',
  'ai-smart-button.feedback-action.feedback-entry-suggest-heading': 'Dejte nám vědět, co byste chtěli zlepšit',
  'ai-smart-button.feedback-action.leave-comment-option': 'Zanechat komentář',
  'ai-smart-button.feedback-action.privacy-policy-link': 'Zásady ochrany osobních údajů {product}.',
  'ai-smart-button.feedback-action.report-bug-option': 'Ohlásit chybu',
  'ai-smart-button.feedback-action.research-participation-message': 'Chci se zúčastnit produktového průzkumu',
  'ai-smart-button.feedback-action.select-feedback-heading': 'Vybrat zpětnou vazbu',
  'ai-smart-button.feedback-action.submit-button-label': 'Odeslat zpětnou vazbu',
  'ai-smart-button.feedback-action.suggest-improvement-option': 'Navrhnout zlepšení',
  'ai-smart-button.feedback-action.title': 'Odeslat zpětnou vazbu',
  'ai-smart-button.feedback-item.icon-label': 'Ikona zpětné vazby',
  'ai-smart-button.reference.close-button-label': 'Zavřít',
  'ai-smart-button.tooltip.label': 'Zeptat se Rovo AI',
  'quick-summary.feedback.summary.placeholder': 'Co udělala Atlassian Intelligence dobře? Co bychom mohli zlepšit?',
  'quick-summary.feedback.title': 'Pomozte nám zlepšit Atlassian Intelligence',
};
